import { render } from "./AttachmentSelectionPanel.vue?vue&type=template&id=20bf2a99&scoped=true"
import script from "./AttachmentSelectionPanel.vue?vue&type=script&lang=js"
export * from "./AttachmentSelectionPanel.vue?vue&type=script&lang=js"

import "./AttachmentSelectionPanel.vue?vue&type=style&index=0&id=20bf2a99&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20bf2a99"]])

export default __exports__